import { MonteCarloPercentilesDTO } from '../../../../types/monteCarlo.types';

export const SM_BREAK = 640;

export enum AnnotationsIds {
  PrincipalRetirement = 'principal-retirement',
  PrincipalLife = 'principal-life',
  SpouseRetirement = 'spouse-retirement',
  SpouseLife = 'spouse-life',
  FundsAtRetirement = 'funds-at-retirement',
}

export enum PlanSeriesName {
  Current = 'Current',
  Recommended = 'Recommended',
}

export interface RetirementAssetsChartDataDTO {
  PrincipalName: string;
  PrincipalRetirementIndex: number;
  PrincipalRetirementAge: number;
  PrincipalLifeExpectancyIndex: number;
  PrincipalLifeExpectancy: number;
  HasSpouse: boolean;
  SpouseName: string | null;
  SpouseRetirementIndex: number;
  SpouseRetirementAge: number;
  SpouseLifeExpectancyIndex: number;
  SpouseLifeExpectancy: number;
  Categories: string[];
  Series: {
    [PlanSeriesName.Current]: number[];
    [PlanSeriesName.Recommended]: number[];
  };
}

export type RetirementChartMilestoneAnnotations = Pick<
  MonteCarloPercentilesDTO,
  | 'PrincipalName'
  | 'PrincipalRetirementIndex'
  | 'PrincipalRetirementAge'
  | 'PrincipalLifeExpectancyIndex'
  | 'PrincipalLifeExpectancy'
  | 'HasSpouse'
  | 'SpouseName'
  | 'SpouseRetirementIndex'
  | 'SpouseRetirementAge'
  | 'SpouseLifeExpectancyIndex'
  | 'SpouseLifeExpectancy'
>;

export interface RetirementAssetsChartDTO {
  Title: string;
  IsEmpty: boolean;
  PdfOnly: boolean;
  Route: string | null;
  Type: string | null;
  Data: RetirementAssetsChartDataDTO;
}
